import React from 'react'
import styled from 'styled-components'
import { title } from 'change-case'

import { IconButton } from 'react-mdl'
import { Link } from 'react-router-dom'
import ContentSection from '../../../../components/ContentSection'

const QuestionContent = styled.span`
  display: flex;
  flex-direction: row;
  border: 1px solid #888;
  padding: 0.25em;
`
const QuestionContentLabel = styled.div`margin-right: 0.25em;`
const QuestionContainer = styled.div`
  position: relative;
  border: 1px solid black;
  padding: 0.25em;
  margin-bottom: 0.5em;
`
const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
`

const MultiChoiceAnswer = styled.div`
  padding: 0;
`

export default function QuestionPanel({
  type,
  questionText,
  answer,
  sectionIndex,
  questionIndex,
  multiChoiceOptions,
}) {

  function typeToTitle(questionType) {
    switch(questionType) {
      case 'review': return 'Review Question';
      case 'final': return 'Final Theory Question';
      case 'review-multi': return 'Review Question - Multiple Choice';
      case 'final-multi': return 'Final Theory Question - Multiple Choice';
      default: return 'Final Theory Question'
    }
  }

  function isMulti(questionType) {
    return questionType.indexOf('-multi') > 0
  }

  return (
    <QuestionContainer>
      <QuestionHeader>
        <span>
          {typeToTitle(type)}
        </span>
        <span>
          <Link to={`./${sectionIndex.join('.')}/question/${questionIndex}`}>
            <IconButton name="edit" colored />
          </Link>
          <Link
            to={`./${sectionIndex.join(
              '.',
            )}/question/${questionIndex}/mapping`}>
            <IconButton name="map" accent />
          </Link>
        </span>
      </QuestionHeader>
      <QuestionContent>
        <QuestionContentLabel>Q:</QuestionContentLabel>
        <ContentSection content={questionText} />
      </QuestionContent>
      {
        isMulti(type) 
        ?
        <QuestionContent>
          <QuestionContentLabel>A:</QuestionContentLabel>
          <div>
            {multiChoiceOptions && 
              multiChoiceOptions.filter(x => x.isAnswer).map((option, i) => (<MultiChoiceAnswer>{option.text}</MultiChoiceAnswer>))
            }
          </div>
        </QuestionContent>
        :
        <QuestionContent>
          <QuestionContentLabel>A:</QuestionContentLabel>
          <ContentSection content={answer} />
        </QuestionContent>
      }
    </QuestionContainer>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/QuestionPanel.js